import { createAtomState } from '@/ui/utilities/state/jotai/utils/createAtomState';

export const isNavigationDrawerCollapsedState = createAtomState<boolean>({
  key: 'isNavigationDrawerCollapsedState',
  defaultValue: false,
  persistInLocalStorage: true,
});
